export enum ErrorName {
  ABORT_ERROR = 'AbortError',
}
